// extracted by mini-css-extract-plugin
export default {"binary-data-bar":"BinaryDataBar_binary-data-bar__dVybz"};